import {connect} from 'react-redux';
import {AnyAction, Dispatch} from 'redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import * as AttachmentsActions from '../actions/AttachmentsActions';
import {LOAN_APPLICATION_MX} from '../../../constants/LabelConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as DocumentTypesConstants from '../../../../common/constants/DocumentTypesConstants';
import {ON_CHANGE_FILE_MENU_ITEM} from '../actions/AttachmentMenuActions';
import {SUB_MENU_FILES_ATTACHMENTS} from '../constants/MenuConstants';
import {DocsState} from '../types/reducers';
import {AttachmentsFormFieldErrors, DocumentTypes, FileState, VersionState} from '../types/types';
import AttachmentUploadFilesView from '../components/views/AttachmentUploadFilesView';
import {FormFieldProps, SimpleMenu} from '../../../../common/types/components';
import {AttachmentUploadFilesDispatchProps, AttachmentUploadFilesStateProps} from '../types/containers';
import {OTHER_TYPE} from '../../../../common/constants/FileTypeConstants';

const mapStateToProps = (state: State, ownProps): AttachmentUploadFilesStateProps => {
    const docsState: DocsState = state.commonLoanApplication.docs;
    const fieldsError: AttachmentsFormFieldErrors =
        state.commonLoanApplication.docs.ui.attachmentsFormView.fieldErrors;
    const showOnlyOtherDocuments = ownProps.data?.showOnlyOtherDocuments || false;
    const isSupervisor = ownProps.data?.isSupervisor || false;
    let canUploadMoreFiles = true;
    const canUploadMultipleFiles = true;
    if (docsState.attachmentsForm.documentTypeSelected?.id === DocumentTypesConstants.OFFICIAL_IDENTIFICATION_BACK_TYPE
        || docsState.attachmentsForm.documentTypeSelected?.id === DocumentTypesConstants.OFFICIAL_IDENTIFICATION_TYPE) {
        canUploadMoreFiles = docsState.attachmentsForm.files?.filter(x => x.isUploaded).length === 0;
    }
    let docsTypes = docsState.catalogs.documentTypes.filter(x => showOnlyOtherDocuments ?
        x.classificationId === DocumentTypesConstants.OTHER_DOCUMENTS_TYPE :
        x.classificationId !== DocumentTypesConstants.OTHER_DOCUMENTS_TYPE);
    if (showOnlyOtherDocuments) {
        docsTypes = docsTypes.filter(
            x => isSupervisor ? x.id !== DocumentTypesConstants.RECORD_DISBURSEMENT_DELAYED_DOCUMENT_TYPE :
                x.id === DocumentTypesConstants.RECORD_DISBURSEMENT_DELAYED_DOCUMENT_TYPE
        );
    }
    return {
        canUploadMultipleFiles,
        canUploadMoreFiles,
        documentTypes: docsTypes,
        documentsVersionId: docsState.attachmentsForm.documentsVersionId,
        documentsVersionName: docsState.attachmentsForm.documentsVersionName,
        documentTypeSelected: new FormFieldProps(docsState.attachmentsForm.documentTypeSelected,
            fieldsError.documentTypeSelectedFieldError),
        files: docsState.attachmentsForm.files,
        filesError: fieldsError.filesViewFieldError,
        ownerName: `${state.admin.profile.firstName} ${state.admin.profile.lastName}`,
        formType: docsState.attachmentsForm.formType,
        documentState: docsState,
        versions: docsState.attachmentsForm.versions
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): AttachmentUploadFilesDispatchProps => {
    return {
        onChangeDocumentType: (documentState: DocsState) => (type, error: string) => {
            if (!!type) {
                delete type.value;
                const classification: SimpleMenu = SUB_MENU_FILES_ATTACHMENTS.filter(submenu =>
                    submenu.id === type.classificationId
                ).pop();
                dispatch((ON_CHANGE_FILE_MENU_ITEM.action(classification)));
            }
            dispatch(AttachmentsActions.ON_CHANGE_DOCUMENT_TYPE.action(type, documentState, error));
        },
        onDropFiles: (ownerName: string) => (files: FileList, error: string) =>
            dispatch(AttachmentsActions.SELECT_FILES_ACTION.action(files, ownerName, error)),
        onDeleteFile: (documentType: DocumentTypes, documentsVersionId: string) => (file: FileState) => {
            const isUploadedFile: boolean = file.isUploaded;
            if (isUploadedFile) {
                const header = {
                    title: LOAN_APPLICATION_MX.FILE_DELETE_CONFIRM_TITLE
                };
                const content = {
                    type: MODAL_TYPE.ATTACHMENT_DELETE_CONFIRM,
                    data: {file, documentType, documentsVersionId}
                };
                const options = {
                    closeOnOverlayClick: false,
                    openSecondModal: true
                };
                dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(header, content, null, options));
            }
            else dispatch(AttachmentsActions.DELETE_LOAN_ATTACHMENT_ACTION_SUCCESSFUL.action(file));
        },
        onCancel: () => dispatch(ModalActions.CLOSE_MODAL_ACTION.action()),
        onPressCreateVersion: (documentType: DocumentTypes) => () => {

            const header = {
                title: LOAN_APPLICATION_MX.FILE_CREATE_NEW_VERSION_CONFIRM_TITLE
            };
            const content = {
                type: MODAL_TYPE.ATTACHMENT_CREATE_NEW_VERSION_CONFIRM,
                data: {documentType}
            };
            const options = {
                closeOnOverlayClick: false,
                openSecondModal: true
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(header, content, null, options));
        },
        onPressUploadFiles: (documentsVersionId: string, documentType: DocumentTypes) => (files: FileState[]) => {
            dispatch(AttachmentsActions.UPLOAD_LOAN_ATTACHMENTS_ACTION_REQUEST
                .action(files, documentType, documentsVersionId));
        },
        toggleTree: (itemVersion: VersionState) => () => {
            dispatch(AttachmentsActions.ON_PRESS_TOGGLE_TREE.action(itemVersion));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const ownerName: string = stateProps.ownerName;
    const documentState: DocsState = stateProps.documentState;
    const documentsVersionId: string = stateProps.documentsVersionId;
    const documentTypeSelected: DocumentTypes = stateProps.documentTypeSelected.value;
    return {
        ...stateProps,
        ...dispatchProps,
        onDropFiles: dispatchProps.onDropFiles(ownerName),
        onChangeDocumentType: dispatchProps.onChangeDocumentType(documentState),
        onPressUploadFiles: dispatchProps.onPressUploadFiles(documentsVersionId, documentTypeSelected),
        onDeleteFile: dispatchProps.onDeleteFile(documentTypeSelected, documentsVersionId),
        onPressCreateVersion: dispatchProps.onPressCreateVersion(documentTypeSelected),
        versions: stateProps.versions.map(version => ({
            ...version,
            toggleTree: dispatchProps.toggleTree(version)
        }))
    };
};

const AttachmentUploadFilesContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(AttachmentUploadFilesView);

export default AttachmentUploadFilesContainer;
